export default class BackofficeOrdersNew {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    this.initializeSelect2();
    this.setupFormValidation();
    this.setupInputChangeListener();
  }

  initializeSelect2() {
    let $select2 = $("#options_select");
    $select2.select2({
      multiple: true,
      closeOnSelect: false
    });
    $select2.val("");
    $select2.trigger("change");
    $select2.change(this.onOptionChanged.bind(this));
  }

  setupFormValidation() {
    $("#order-form-submit").on('click', (event) => {
      // Populate options before validation/submit
      this.populateOptionsField();

      this.validateFormFields();
      const emailValid = this.validateEmail();
      const phoneValid = this.validatePhone();

      if (!this.isFormValid(emailValid, phoneValid)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      return true;
    });
  }

  populateOptionsField() {
    const optionsSelect = document.getElementById('options_select');
    const optionsInput = document.querySelector('input[name="options"]');
    
    if (optionsSelect && optionsInput) {
      const selectedValues = $(optionsSelect).val() || [];
      optionsInput.value = selectedValues.join(',');
      console.log('Options being submitted:', optionsInput.value);
    }
  }

  validateFormFields() {
    $("#order-form input, #order-form select, #order-form textarea").each(function() {
      if (!$(this).prop('readonly')) {
        if (!this.checkValidity()) {
          $(this).addClass('is-invalid');
          if ($(this).next('.invalid-feedback').length === 0) {
            $(this).after('<div class="invalid-feedback">Ce champ est obligatoire.</div>');
          }
        } else {
          $(this).removeClass('is-invalid').addClass('is-valid');
          $(this).next('.invalid-feedback').remove();
        }
      }
    });
  }

  validateEmail() {
    let email = $("#customer_contact_email").val();
    let emailValid = !email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!emailValid) {
      this.showErrorMessage('customer_contact_email', 'Merci de saisir une adresse email valide.');
    } else {
      this.hideErrorMessage('customer_contact_email');
    }

    return emailValid;
  }

  validatePhone() {
    let phone = $("#customer_contact_phone").val();
    let phoneValid = !phone || /^(\+33|0)[1-9](\d{2}){4}$/.test(phone);

    if (!phoneValid) {
      this.showErrorMessage('customer_contact_phone', 'Merci de saisir un numéro de téléphone valide.');
    } else {
      this.hideErrorMessage('customer_contact_phone');
    }

    return phoneValid;
  }

  isFormValid(emailValid, phoneValid) {
    return $("#order-form")[0].checkValidity() && emailValid && phoneValid;
  }

  setupInputChangeListener() {
    $("#order-form input, #order-form select, #order-form textarea").on('input change', function() {
      $(this).removeClass('is-invalid is-valid');
      $(this).next('.invalid-feedback').remove();
    });
  }

  showErrorMessage(fieldId, message) {
    const field = $(`#${fieldId}`);
    field.addClass('is-invalid');
    if (field.next('.invalid-feedback').length === 0) {
      field.after(`<div class="invalid-feedback">${message}</div>`);
    }
  }

  hideErrorMessage(fieldId) {
    const field = $(`#${fieldId}`);
    field.removeClass('is-invalid');
    field.next('.invalid-feedback').remove();
  }

  onOptionChanged(e) {
    let options = $("#options_select option:selected");
    let fas = 0;
    let subscription = 0;

    options.each(function() {
      fas += Number.parseFloat($(this).data("fas"));
      subscription += Number.parseFloat($(this).data("subscription"));
    });

    this.updateOptionTotals(fas, subscription);
  }

  updateOptionTotals(fas, subscription) {
    // Check if we have separate columns for annual pricing
    let hasSeperateColumns = $("#subscription_options_total").length > 0;

    // Always update the FAS options and total
    const fasTotalValue = Number.parseFloat($("#fas_product").data("price")) || 0;
    $("#fas_options").text(I18n.toCurrency(fas));
    $("#fas_total").text(I18n.toCurrency(fasTotalValue + fas));

    // Update subscription: either separate or combined
    $("#subscription_options").text(I18n.toCurrency(subscription));
    if (hasSeperateColumns) {
      // Annual pricing: keep options total separate
      $("#subscription_options_total").text(I18n.toCurrency(subscription));
    } else {
      // Regular pricing: combine product + options
      const basePrice = Number.parseFloat($("#subscription_product").data("price")) || 0;
      $("#subscription_total").text(I18n.toCurrency(basePrice + subscription));
    }

    // Update summary section with same logic
    $("#summary_fas_options").text(I18n.toCurrency(fas));
    $("#summary_fas_total").text(I18n.toCurrency(fasTotalValue + fas));
    $("#summary_subscription_options").text(I18n.toCurrency(subscription));

    if (hasSeperateColumns) {
      if ($("#summary_subscription_options_total").length > 0) {
        $("#summary_subscription_options_total").text(I18n.toCurrency(subscription));
      }
    } else {
      const basePrice = Number.parseFloat($("#subscription_product").data("price")) || 0;
      if ($("#summary_subscription_total").length > 0) {
        $("#summary_subscription_total").text(I18n.toCurrency(basePrice + subscription));
      }
    }
  }

  onDataChanged(data) {
    // Implementation for data change handling
  }

  onDestroy() {
    $("#options_select").select2("destroy");
  }
}